module.exports = __webpack_public_path__ + "static/img/lucre-games-coin-low-poly-3d-rotating.9000997.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-coin-low-poly-3d-rotating.gif
// module id = XPB6
// module chunks = 0